import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Sidebarmenu from "../../Sidebar/Sidebarmenu";
import axios from "axios";

import user_icon from "../../../img/Icon/user_icon.svg";
import email_icon from "../../../img/Icon/email.svg";
import phone_icon from "../../../img/Icon/phone.svg";
import ven from "../../../img/ven.png";
import starticon from "../../../img/Icon/starticon.png";
import { toast } from "react-toastify";
import loadergif from '../../../img/landing/loader123.gif';
import Select from "react-select";
import remove from "../../../img/remove.png";


import {
  getAllRegIngredients,
  getDishType,
  getAllcaterer,
  menu_schedule,
  fmb_food_items_dish,
  fmb_food_items_ingredients,
} from "../../../Redux/Reducer/AuthReducer";

export default function IngredientDishes() {
  const user_Role = localStorage.getItem("access_Role");
  var token = localStorage.getItem("access_token");
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [item_id, setIngredientId] = useState("");

  const access_id = localStorage.getItem("access_id");

  const item = location.state?.item
  const naviagte_dishes = location.state?.dishes

 item?.id && localStorage.setItem("item_id", item?.id);

  useEffect(() => {
    getCatererData();
    getingrident();
    getDishtypedata()
  }, []);

const [cleartype, setCleartype] = useState([]);
  const [catererdata, setCatererdata] = useState("");
  const [ingredientcount, setIngredientCount] = useState("0");
  const fileInputRef = useRef(null);
  const [RemoveIsOpen, setIsRemoveOpen] = React.useState(false);
  const [ViewIsOpen, setIsViewOpen] = React.useState(false);
  
  const [dishes, setDishes] = useState(naviagte_dishes);

  const [dishesnamelist, setDishesNameList] = useState([]);
  const [value, setValue] = useState([]);
  const [src, setSrc] = useState(null);
  const [image, setImage] = useState();
  const [unitdata, setUnitdata] = useState([]);
  const [unitdataall, setUnitdataall] = useState([]);
  const [itemSelect, setItemSelect] = useState([]);
  const [name, setName] = useState("");
  const [dishnote, setDishNote] = useState();
  const [dishPackagingType, setDishPackagingType] = useState({ value: "General", label: "General" });

  const [dishXSmallMulti, setDishXSmallMulti] = useState();
  const [dishOneTwoMulti, setDishOneTwoMulti] = useState();
  const [dishThreeFourMulti, setDishThreeFourMulti] = useState();
  const [dishFiveSixMulti, setDishFiveSixMulti] = useState();

  const [quantityname, setquantityname] = useState([]);
  const [type, setType] = useState([]);
  const [cater, setCater] = useState("");
  const [ingredients, setIngredients] = useState("");
  const [quality, setQuality] = useState([]);
  const [unit, setUnit] = useState([]);
  const [state, setState] = useState([]);
  const [caterer, setCaterer] = useState([]);
  const [catererList, setCatererList] = useState("");
  const [inderedientList, setInderedientList] = useState([]);
  const [selectedvalue, setselectedvalue] = useState([]);
  const [dishname, setDishname] = useState([]);
  const [editdishtype, setEditDishType] = useState("");
  const [updateimage, setUpdateimage] = useState(null);
  const [dishview, setDishView] = useState([]);
  const [catererAllNames, setCatererAllNames] = useState("");
  const [optiondata, setoptiondata] = useState("");
  const [IngredientsOption, setIngredientsOption] = useState("");
  const [UnitOption, setUnitOption] = useState("");
  const [dishnum, setDishNum] = useState([])
  const dishviewdata = Object?.values(dishview);
  const [id, setId] = useState("");
  const [duplicateCount, setDuplicateCount] = useState(1);
  const [updateid, setUpdateId] = useState("");
  const [dishtypelist, setDishTypeList] = useState("");
  const [catererlist, setCatererlist] = useState([]);
  const [totalPages, setTotalPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortColumn, setSortColumn] = useState('created_at');
  const [sortOrder, setSortOrder] = useState('asc');
  const [roticheck, setRotiCheck] = useState("1");
  const [ricecheck, setRiceCheck] = useState("1");
  const [totalcount, setTotalCount] = useState('');
  const [validationerror, setValidationerror] = useState(false)
  const [alldishid, setAllDishId] = useState('')
  const [EventIsOpen, setIsEventOpen] = React.useState(false);
  const [EventType, setEventType] = useState([]);
  const [niyaztype, setNiyazType] = useState({ value: "0", label: "FMB Thali" });
  const [unitdatalist, setunitDatalist] = useState([]);
  const [ingredientlistdata, setingredientlistdata] = useState([]);
//   const [niyaaz_type_view, setNiyaazTypeView] = useState(schedule_type == 'MIQAAT' ? 1 : 0);
  

  const ingredientRef = useRef(null);
  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#AE8340" : null,
        boxShadow: isFocused ? "none" : "none",
        color: "#333333",
      };
    },
  };

let dishTypeListData = [];
  if (Array.isArray(dishtypelist)) {
    dishTypeListData = dishtypelist.map((item) => ({
      label: item.dish_type,
      value: item.id,
    }));
  } else {
    console.error("dishtypelist is not an array or is undefined");
  }

 const NiyazListData = [
    {   label: "FMB Thali", value: 0 },
    {  label: "Miqaat", value: 1 },
  ];

  const PackagingListData = [
    {   label: "General", value: "General" },
    {  label: "Outsource", value: "Outsource" },
  ];

 const preventMinus = (e) => {
    if (e.code === 'Minus') {
        e.preventDefault();
    }
};

  var ingredientsArray = [];
  var ingredients2 = {
    ingredient_id: '',
    quantity: '',
    unit: '',
    ingredient_name: ''
  };
  ingredientsArray.push(ingredients2);

    const getCatererData = () => {
      dispatch(getAllcaterer()).then((res) => {
        if (res?.payload?.status == true) {
          setCatererlist(res?.payload?.data);
        } else {
          toast.error(res?.payload?.message);
        }
      });
    };

    const getingrident = () => {
    dispatch(getAllRegIngredients()).then((res) => {
        if (res?.payload?.status === true) {
        setItemSelect(res?.payload?.data);
        } else {
        toast.error(res?.payload?.message);
        }
    });
    };
  

  const getDishtypedata = () => {
    dispatch(getDishType()).then((res) => {
      if (res?.payload?.status === true) {
        setDishTypeList(res?.payload?.data);
      } else {
        toast.error(res?.payload?.message);
      }
    })
  };



    const getCatererlistdata = catererlist.map((item) => {
      return {
        label: `${item?.first_name} ${item?.last_name ? item?.last_name : '-'}`,
        value: item.id,
      };
    });

   const ingredientlist = itemSelect.map((item) => {
    return {
      label: item.ingredient_name,
      value: item.id,
      package: item.package_unit,
      unit: item.unit,
    };
   });


    const getIngredientDishes = async () => {
         setLoading(true);
         //
         try {
         const headers = {
           Accept: "application/json",
           "Content-Type": "application/json", // Assuming you're sending form data
           Authorization: localStorage.getItem("access_token"),
         };
   
         const response = await fetch(
           fmb_food_items_ingredients +
             `admin/ingredients-dish-search?ingredient_id=${item.id}`,
           {
             method: "GET",
             headers: headers,
           }
         );
         if (response.ok) {
           const data = await response.json();
           console.log("data:", data); // Check the structure of the received data
           const dishes = data?.data;
           setDishes(dishes)
         } else {
           console.log("Error: ", response.status);
         }
       } catch (error) {
         console.log("Error: ", error);
       }
     }
   

   const handleRemoveSection = (index) => {
        const newDishNum = [...dishnum];
        newDishNum.splice(index, 1);
        setDishNum(newDishNum);
    
        const newIngredientListData = [...ingredientlistdata];
        newIngredientListData.splice(index, 1);
        setingredientlistdata(newIngredientListData);
    
        const newQuantityName = [...quantityname];
        newQuantityName.splice(index, 1);
        setquantityname(newQuantityName);
    
        const newUnitDataList = [...unitdatalist];
        newUnitDataList.splice(index, 1);
        setunitDatalist(newUnitDataList);
   };

    const handleSubmitUpdate = (e) => {
    console.log ("handleSubmitUpdate")
    e.preventDefault();
    e.preventDefault();
    const updatedIngredientsList = ingredientlistdata.filter((ingredient) => ingredient !== 0)
    const updatedQuanityName = quantityname.filter((quantity) => quantity !== 0)
    const updatedUnitDataList = unitdatalist.filter((unit) => unit !== 0)
    const obj = updatedIngredientsList.map((ingredient, i) => ({
      index: i,
      ingredient_id: ingredient,
      quantity: updatedQuanityName[i],
      unit: updatedUnitDataList[i],
    }));
    console.log(obj)
    if (!name ||
      !optiondata ||
      !catererdata
    ) {
      setValidationerror(true)
      return false
    }
    else {
      const postData = {
      dish_name: name,
      dish_type: optiondata,
      is_active: 1,
      caterer_id: catererdata,
      allow_skip_rice: ricecheck,
      dish_id: updateid,
      allow_skip_roti: roticheck,
      cutting_instructions: "1",
      general_instructions: "1",
      quantity_updated_from: "1",
      dish_note: dishnote,
      dish_packaging_type: dishPackagingType?.value,
      x_small_multi: dishXSmallMulti,
      one_two_multi: dishOneTwoMulti,
      three_four_multi: dishThreeFourMulti,
      five_six_multi: dishFiveSixMulti,
      created_user: access_id,
      updated_user: access_id,
      source: "web",
      ingredient: JSON.stringify(obj),
      niyaz_type_description: niyaztype?.label,
      niyaaz_type: niyaztype?.value
      }
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      };
      axios
        .put(fmb_food_items_dish + `admin/dish/update`, postData, config, {})
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(res?.data?.message);
            setName("");
            setQuality("");
            setUnit("");
            setValidationerror(false)
            getIngredientDishes();
            const modal_close2 = document.getElementById("modal_close_btn2").click();
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(error => {
          // Handle any errors that occur during the request
          console.error(error);
          toast.error(error);
      });
    };
  }

  const dishdata1 = (dish, skip) => {
    const dishlist = dish;
    const ingredients = dish?.ingredients ? dish?.ingredients : ingredientsArray;
    const ingredientQuantities = ingredients?.map((ingredient) => ingredient?.quantity);
    setquantityname(ingredientQuantities);
    const ingredientid = ingredients?.map((ingredient) => ingredient?.ingredient_id);
    setingredientlistdata(ingredientid);
    const ingredientunit = ingredients?.map((ingredient) => ingredient?.unit);
    setunitDatalist(ingredientunit);
    setName(dishlist?.dish_name);
    setDishPackagingType(dishlist?.dish_packaging_type);

    setDishXSmallMulti(dishlist?.x_small_multi);
    setDishOneTwoMulti(dishlist?.one_two_multi);
    setDishThreeFourMulti(dishlist?.three_four_multi);
    setDishFiveSixMulti(dishlist?.five_six_multi);

    setDishNote(dishlist?.dish_note);
    setoptiondata(dishlist?.dish_type);
    // setCatererdata(dishlist?.caterer_id);
    setRiceCheck(dishlist?.allow_skip_rice)
    setRotiCheck(dishlist?.allow_skip_roti)
    !skip && setCatererdata(dishlist?.caterer_id ? dishlist?.caterer_id : dish?.caterer_id);
    setIngredientCount(dishlist?.ingredient_count);
    
    //Update Niyaz Type
    const dishNiyaz = { value: dishlist?.niyaaz_type, label: dishlist?.niyaz_type_description };
    setNiyazType(dishNiyaz);

    const dishIdToStore = dishlist.dish_id ? dishlist.dish_id : dishlist.dish_ids;
    localStorage.setItem('dish_id', dishIdToStore);

    setAllDishId(dishIdToStore);
    setQuality(ingredientQuantities);
    setUnit(ingredientunit);
    setingredientlistdata(ingredientid);
  }


   const ChangeStatusActive = (dish_id) => {
      setLoading(true);
      fetch(fmb_food_items_dish + `admin/dish/activate/${dish_id}`, {
        method: 'PUT',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      })
        .then(response => response.json())
        .then(data => {
          if (data?.status == true) {
            toast.success(data?.message);
          } else {
            // Handle error response
            toast.error(data?.message);
          }
        })
        .catch(error => {
          // Handle any errors that occur during the request
          console.error(error);
        }) .finally(() => {
          setLoading(false); // Set loading state to false after data has been fetched or in case of an error
        });
  
    };
  
    const ChangeStatusInActive = (dish_id) => {
      setLoading(true);
      fetch(fmb_food_items_dish + `admin/dish/inactivate/${dish_id}`, {
        method: 'PUT',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      })
        .then(response => response.json())
        .then(data => {
          if (data?.status == true) {
            toast.success(data?.message);
          } else {
            // Handle error response
            toast.error(data?.message);
          }
        })
        .catch(error => {
          // Handle any errors that occur during the request
          console.error(error);
        }) .finally(() => {
          setLoading(false); // Set loading state to false after data has been fetched or in case of an error
        });
  
    }

  const VeswDishesId = (id, caterer_id, skip) => {
    setLoading(true);
    const requestBody = {
      dish_id: id,
      caterer_id: caterer_id ? caterer_id : ""
    };

    fetch(menu_schedule + 'admin/dish-get', {
      method: 'POST',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("access_token"),
      },
      body: JSON.stringify(requestBody),
    })
      .then(response => response.json())
      .then(data => {
        if (data?.success == true) {
          console.log('ddd', data.data ? data.data : data.payLoad)
          console.log('data.payLoad.caterer_all_names', data.payLoad.caterer_all_names)
          dishdata1(data.data ? data.data : data.payLoad, skip);
          setDishView(data.data ? data.data : data.payLoad)
          setCatererAllNames(data.payLoad.caterer_all_names)
          if (data?.data) {
            setDishNum(data.data.ingredients ? data.data.ingredients : ingredientsArray);
          } else {
            // If data.data is null or undefined, you can handle it here.
            // For example, set a default value or handle the case accordingly.
            // Here, we are assuming ingredientsArray is a suitable default.
            setDishNum(ingredientsArray);
          }
          setUpdateId(data?.data?.dish_ids ? data?.data?.dish_ids : data?.payLoad?.dish_ids)
        } else {
          // Handle error response
          toast.error(data?.message);
        }
      })
      .catch(error => {
        // Handle any errors that occur during the request
        console.error(error);
      }) .finally(() => {
        setLoading(false); // Set loading state to false after data has been fetched or in case of an error
      });
  };

const handleIngredientUpdate = (e, index) => {    
    //Update Ingredient
    const newIngredientListData = [...ingredientlistdata];
    newIngredientListData[index] = e.value;
    setingredientlistdata(newIngredientListData);

    //Update Unit
    const newunit = [...unitdatalist];
    newunit[index] = e.unit;
    setunitDatalist(newunit);

  };


  const handleCopyDefaultIngredients = () => {
        VeswDishesId(alldishid, "1", true)
  };

    const handleAddSection = () => {
    // const newIngredient = { ingredient_id: null, ingredient_name: '', quantity: 0, unit: ''}
    const newDishNum = dishnum;
    newDishNum.unshift(0);//[...dishnum, dishnum?.length + 1];
    setDishNum([...newDishNum]);

    const newIngredientListData = ingredientlistdata
    ingredientlistdata.unshift(0)
    setingredientlistdata(newIngredientListData)

    const newQuantityName = [...quantityname];
    newQuantityName.unshift(0);
    setquantityname(newQuantityName);
  
    const newUnitDataList = [...unitdatalist];
    newUnitDataList.unshift(0);
    setunitDatalist(newUnitDataList);

    console.log(newDishNum)
    console.log(ingredientlistdata)
  };


///



const handleNavigateDishPage = (dish_name, schedule_type) => {
setTimeout(() => {
    navigate('/Dishes', { state: { schedule_type: '0', dish_name: dish_name} });
}, 20);
};

  return (
    <div>
      <Header />
      <div className="side_div_menu" style={{ display: "flex", height: "100%" }}>
      <Sidebarmenu />
            <section className="main_section">
            <div className="custam">
            <div className="main_section2">
            <div className="ExportInventory thali_section Thali_page"></div>
            <div className="thali_table_user_section">
            <div className="container-fluid">
                <div className="thili_div">
                <div className="Back-page">
                    {" "}
                    <h1 className="title_heading">
                        Ingredient Dishes ({dishes ? dishes.length : "-"})
                    </h1>{" "}
                </div>
                </div>
                <div className="thali_table_section">
                <table className="table table-bordered table-responsive">
                    <thead className="thead-dark">
                    <tr>
                        <th scope="col">
                        <span className="thali_table">Dish Name</span>
                        </th>
                        <th scope="col">
                        <span className="thali_table">Dish Type</span>
                        </th>
                        <th scope="col">
                        <span className="thali_table">Ingredient Name</span>
                        </th>
                        <th scope="col">
                        <span className="thali_table">Quantity</span>
                        </th>
                        <th scope="col">
                        <span className="thali_table">Unit</span>
                        </th>
                        <th scope="col">
                        <span className="thali_table">Schedule Type</span>
                        </th>
                        <th scope="col">
                        <span className="thali_table">Action</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {dishes &&
                        dishes.map((item) => {
                        return (
                            <tr key={item.id}>
                            <th scope="row">
                                <Link onClick={() => handleNavigateDishPage(item.dish_name, item.schedule_type)}>
                                <div style={{ fontSize: 14, fontWeight: '420', color: "#2E294E" }}>{item.dish_name ? item.dish_name : '-'}</div>
                                </Link>
                            </th>
                            <th scope="row">
                                <div style={{ fontSize: 14, fontWeight: '420', color: "#2E294E" }}>{item.dish_type ? item.dish_type : '-'}</div>
                            </th>
                            <th scope="row">
                                <div style={{ fontSize: 14, fontWeight: '420', color: "#2E294E" }}>{item.ingredient_name ? item.ingredient_name : '-'}</div>
                            </th>
                            <th scope="row">
                                <div style={{ fontSize: 14, fontWeight: '420', color: "#2E294E" }}>{item.quantity ? item.quantity : '-'}</div>
                            </th>
                            <th scope="row">
                                <div style={{ fontSize: 14, fontWeight: '420', color: "#2E294E" }}>{item.unit ? item.unit : '-'}</div>
                            </th>
                            <th scope="row">
                                <div style={{ fontSize: 14, fontWeight: '420', color: "#2E294E" }}>{item.niyaz_type_description ? item.niyaz_type_description : '-'}</div>
                            </th>
                                <th scope="row">
                                <ul className="thali_menu_list">
                                    <li>
                                    <div className="dropdown action_btn">
                                        <button
                                        className="btn btn-secondary dropdown-toggle"
                                        type="button"
                                        id="dropdownMenuButton2"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        >
                                        <i
                                            className="fa fa-ellipsis-h"
                                            aria-hidden="true"
                                        ></i>
                                        </button>
                                        <ul
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownMenuButton2"
                                        >
                                        { (user_Role.includes("ADM") || user_Role.includes("OPT") || user_Role.includes("ODM") || user_Role.includes("MIQ") || user_Role.includes("MDM")) &&
                                        <li onClick={() => VeswDishesId(item.id, item.caterer_id)}>
                                            <a
                                            className="dropdown-item"
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#offcanvasRight_edit"
                                            aria-controls="offcanvasRight_edit"
                                            id="view_id"
                                            >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="19"
                                                height="15"
                                                viewBox="0 0 19 15"
                                                fill="none"
                                            >
                                                <path
                                                d="M17.125 8.65L15.35 6.875L16.075 6.15C16.2135 6.01667 16.3898 5.95 16.6039 5.95C16.818 5.95 16.9917 6.01667 17.125 6.15L17.85 6.875C17.9833 7.01352 18.05 7.18982 18.05 7.4039C18.05 7.61797 17.9833 7.79167 17.85 7.925L17.125 8.65ZM9 15V13.225L14.275 7.95L16.05 9.725L10.775 15H9ZM0.75 9.75C0.335787 9.75 0 9.41421 0 9C0 8.58579 0.335786 8.25 0.75 8.25H6.75C7.16421 8.25 7.5 8.58579 7.5 9C7.5 9.41421 7.16421 9.75 6.75 9.75H0.75ZM0.75 5.625C0.335786 5.625 0 5.28921 0 4.875C0 4.46079 0.335786 4.125 0.75 4.125H11C11.4142 4.125 11.75 4.46079 11.75 4.875C11.75 5.28921 11.4142 5.625 11 5.625H0.75ZM0.75 1.5C0.335786 1.5 0 1.16421 0 0.75C0 0.335786 0.335786 0 0.75 0H11C11.4142 0 11.75 0.335786 11.75 0.75C11.75 1.16421 11.4142 1.5 11 1.5H0.75Z"
                                                fill="#777391"
                                                />
                                            </svg>{" "}
                                            &nbsp; &nbsp;Edit Details
                                            </a>
                                        </li>
                                        }
                                        { (user_Role.includes("ADM") || user_Role.includes("OPT") || user_Role.includes("ODM") || user_Role.includes("MIQ") || user_Role.includes("MDM")) &&
                                        <li onClick={() => {item.is_active == '1' ? ChangeStatusInActive(item.id) : ChangeStatusActive(item.id)}}>
                                            <a
                                            className="dropdown-item"
                                            id="view_id"
                                            >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 25 25"
                                                fill="none"
                                            >
                                                {item.is_active == '1' ?
                                                <path
                                                d="m15.707,9.707l-2.293,2.293,2.293,2.293c.391.391.391,1.023,0,1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-2.293-2.293-2.293,2.293c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023,0-1.414l2.293-2.293-2.293-2.293c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l2.293,2.293,2.293-2.293c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414Zm8.293,2.293c0,6.617-5.383,12-12,12S0,18.617,0,12,5.383,0,12,0s12,5.383,12,12Zm-2,0c0-5.514-4.486-10-10-10S2,6.486,2,12s4.486,10,10,10,10-4.486,10-10Z"
                                                fill="#777391"
                                                />
                                                :
                                                <path
                                                d="m16.298,8.288l1.404,1.425-5.793,5.707c-.387.387-.896.58-1.407.58s-1.025-.195-1.416-.585l-2.782-2.696,1.393-1.437,2.793,2.707,5.809-5.701Zm7.702,3.712c0,6.617-5.383,12-12,12S0,18.617,0,12,5.383,0,12,0s12,5.383,12,12Zm-2,0c0-5.514-4.486-10-10-10S2,6.486,2,12s4.486,10,10,10,10-4.486,10-10Z"
                                                fill="#777391"
                                                />
                                            }
                                            </svg>{""}
                                            &nbsp; &nbsp; {item.is_active == '1' ? "In Activate" : "Activate" }
                                            </a>
                                        </li>
                                        }
                                        </ul>
                                    </div>
                                    </li>
                                </ul>
                                </th>
                            </tr>
                        );
                        })}
                    </tbody>
                </table>
                </div>
            </div>
            </div>
            </div>
            </div>
        </section>
      </div>

      {/* Edit Dish */}
        <div
          className="offcanvas offcanvas-end Dishes_canvas"
          tabindex="-1"
          id="offcanvasRight_edit"
          aria-labelledby="offcanvasRight_editLabel"
        >
           {loading ? (
                          // Render a loading indicator while data is being fetched
                          <div className='Loading-img'><img src={loadergif} className='' /></div>
  
                        ) : (
                          <div>   {dishviewdata?.map((dish) => (
                            <div key={dish}>
                              {/* <h3>Dish Name: {dish.dish_name}</h3>
                            <p>Description: {dish.description}</p> */}
                              {/* Add more fields as needed */}
                            </div>
                          ))}</div>
                        )
                        }
       
            
  
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasRight_editLabel">
              Edit Dish
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            {/* <div className="Img_upload">
              <img src={image} className="img-firud uplode_img" />
              <input
                id="img_upload"
                type="file"
                name="image"
                onChange={handleChangeImg}
                className="mb-2"
  
              />
            </div> */}
            <div className="Dish_Name_list">
              <form className="row g-3" onSubmit={handleSubmitUpdate}>
  
              <div className="col-md-6">
              <div className="Form_box">
                    <label for="Portion" className="form-label">
                      Niyaz Type
                    </label>
                    <Select
                      options={NiyazListData}
                      className="dropdown"
                      placeholder="Select Niyaz Type"
                      id="inputrice"
                      styles={colourStyles}
                    
                      value={NiyazListData.find((option) => option.value === niyaztype?.value)}
                      defaultValue={cleartype}
                      onChange={(e) => setNiyazType(e)}
                      isClearable
                      hideSelectedOptions={false}
                    />
                    {/* {
                      validationerror && !portionid &&
                      <p className="show_invalid_text" >  Portion is required</p>
                    } */}
                  </div>
                </div>
  
                <div className="col-md-6">
                  <div className="Form_box">
                    <label for="inputDishName" className="form-label">
                      Dish Packaging Type
                    </label>
                    <Select
                      options={PackagingListData}
                      className="dropdown"
                      placeholder="Select Packaging Type"
                      id="inputrice"
                      styles={colourStyles}
                      value={PackagingListData.find((option) => option.value === dishPackagingType)}
                      defaultValue={cleartype}
                      onChange={(e) => setDishPackagingType(e)}
                      hideSelectedOptions={false}
                    />
                    {/* {
                      validationerror && !portionid &&
                      <p className="show_invalid_text" >  Portion is required</p>
                    } */}
                  </div>
                </div>
  
                <div className="col-md-6">
                  <div className="Form_box">
                    <label for="inputDishName" className="form-label">
                      Dish Name
                    </label>
                    <input
                      type="text"
                      placeholder="Dish Name"
                      className={`${validationerror && !name ? "validation_valid form-control" : "form-control"}`}
                      id="inputDishName"
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
  
                    {
                      validationerror && !name &&
                      <p className="show_invalid_text" >Dish Name is required</p>
                    }
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="Form_box">
                    <label for="inputPassword4" className="form-label">
                      Dish type
                    </label>
                    <Select
                      options={dishTypeListData}
                      className={`${validationerror && !optiondata ? "validation_valid dropdown" : "dropdown"}`}
                      placeholder="Select dish"
                      id="inputState"
                      styles={colourStyles}
                      onChange={(e) => setoptiondata(e.label)}
                      isClearable={false}
                      hideSelectedOptions={false}
                      // defaultValue={editdishtype}
                      // defaultValue={dataget.dish_type}
                      value={dishTypeListData.find((option) => option.label === optiondata)}
                    />
                    {
                      validationerror && !optiondata &&
                      <p className="show_invalid_text" >Dish Type is required</p>
                    }
                  </div>
                </div>
  
                {/* <div className="col-md-6">
                  <div className="Form_box">
                    <label for="Standard" className="form-label">
                      ROTI (Allow Skip)
                    </label>
                    <ul className="thali_menu_list">
                      <div>
                        <div className="Register_user_input">
                          <div className="onoffswitch">
                            <input type="checkbox" name="onoffswitch" className="onoffswitch-checkbox " id="myonoffswitch" checked={roticheck === "1"}
                              onChange={handleToggleChange} />
                            <label className="onoffswitch-label" for="myonoffswitch">
                              <span className="onoffswitch-inner"></span>
                              <span className="onoffswitch-switch"></span>
                            </label>
                          </div>
  
                        </div>
                      </div>
                    </ul>
                  </div>
                </div> */}
                {/* <div className="col-md-6">
                  <div className="Form_box">
                    <label for="Standard" className="form-label">
                      Rice (Allow Skip)
                    </label>
                    <ul className="thali_menu_list">
                      <div>
                        <div className="Register_user_input">
                          <div className="onoffswitch">
                            <input type="checkbox" name="onoffswitch" className="onoffswitch-checkbox" id="rice_check"
                              checked={ricecheck === "1"}
                              onChange={handleToggleChange2} />
                            <label className="onoffswitch-label" for="rice_check">
                              <span className="onoffswitch-inner"></span>
                              <span className="onoffswitch-switch"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div> */}
                <div className="col-md-6">
                  <div className="Form_box">
                    <label for="inputCaterer" className="form-label">
                      Caterer
                    </label>
                    <Select
                      options={[...getCatererlistdata]}
                      className={`${validationerror && !catererdata ? "validation_valid dropdown" : "dropdown"}`}
                      placeholder="Select Catere"
                      styles={colourStyles}
                      onChange={(selectedOption) => {
                        // Assuming selectedOption.value contains the new value
                        setCatererdata(selectedOption.value); // Update the state first
                        VeswDishesId(alldishid, selectedOption.value)
                        // VeswDishesId2(selectedOption.value); // Call your function
                      }}
  
                      isClearable={false}
                      hideSelectedOptions={true}
                      value={getCatererlistdata.find((option) => option.value === catererdata)}
                    />
                    {
                      validationerror && !catererdata &&
                      <p className="show_invalid_text" > Caterer is required</p>
                    }
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="Form_box">
                    <label for="inputDishName" className="form-label">
                      Dish T Note
                    </label>
                    <input
                      type="text"
                      placeholder="Dish Note"
                      className="form-control"
                      id="inputDishName"
                      onChange={(e) => setDishNote(e.target.value)}
                      value={dishnote}
                    />
                    {/* {
                      validationerror && !dishnote && 
                      <p className="show_invalid_text" > Dish Note is required</p>
                    } */}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="Form_box">
                    <label for="inputCaterer" className="Form_box">
                      All Caterers
                    </label>
                    {catererAllNames &&
                    JSON.parse(catererAllNames).map((caterer_name, index) => (
                    <label className="form-control" key={index}>
                          {caterer_name ? caterer_name : "-"}
                    </label>
                    ))}
                  </div>
                </div>
                { (dishPackagingType === 'Outsource' || dishPackagingType?.value === 'Outsource') &&
                <div className="col-md-3">
                  <label htmlFor="Ingredients" className="form-label">
                    (X-S) Multiplier
                  </label>
                </div>
                }
                { (dishPackagingType === 'Outsource' || dishPackagingType?.value === 'Outsource') &&
                <div className="col-md-3">
                  <label htmlFor="Qty" for="Qty" className="form-label">
                    (1-2) Multiplier
                  </label>
                </div>
                }
                { (dishPackagingType === 'Outsource' || dishPackagingType?.value === 'Outsource') &&
                <div className="col-md-3">
                  <label htmlFor="Unit" for="Unit" className="form-label">
                    (3-4) Multiplier
                  </label>
                </div>
                }
                { (dishPackagingType === 'Outsource' || dishPackagingType?.value === 'Outsource') &&
                <div className="col-md-3">
                  <label htmlFor="Unit" for="Unit" className="form-label">
                    (5-6) Multiplier
                  </label>
                </div>
                }
                { (dishPackagingType === 'Outsource' || dishPackagingType?.value === 'Outsource') &&
                <div className="col-md-3">
                  <div className="Form_box">
                    {/* <label htmlFor={`Qty${index}`} for="Qty" className="form-label">
                      Qty
                    </label> */}
                    <input
                      type="number"
                      min="0"
                      step="any"
                      className="form-control"
                      onKeyDown={preventMinus}
                      id={`Qty}`}
                      onWheel={() => document.activeElement.blur()}
                      value={dishXSmallMulti}
                      onChange={(e) => setDishXSmallMulti(e.target.value)}
                    />
                  </div>
                </div>
                }
                { (dishPackagingType === 'Outsource' || dishPackagingType?.value === 'Outsource') &&
                <div className="col-md-3">
                  <div className="Form_box">
                    {/* <label htmlFor={`Qty${index}`} for="Qty" className="form-label">
                      Qty
                    </label> */}
                    <input
                      type="number"
                      min="0"
                      step="any"
                      className="form-control"
                      onKeyDown={preventMinus}
                      id={`Qty}`}
                      onWheel={() => document.activeElement.blur()}
                      value={dishOneTwoMulti}
                      onChange={(e) => setDishOneTwoMulti(e.target.value)}
                    />
                  </div>
                </div>
                }
                { (dishPackagingType === 'Outsource' || dishPackagingType?.value === 'Outsource') &&
                <div className="col-md-3">
                  <div className="Form_box">
                    {/* <label htmlFor={`Qty${index}`} for="Qty" className="form-label">
                      Qty
                    </label> */}
                    <input
                      type="number"
                      min="0"
                      step="any"
                      className="form-control"
                      onKeyDown={preventMinus}
                      id={`Qty}`}
                      onWheel={() => document.activeElement.blur()}
                      value={dishThreeFourMulti}
                      onChange={(e) => setDishThreeFourMulti(e.target.value)}
                    />
                  </div>
                </div>
                }
                { (dishPackagingType === 'Outsource' || dishPackagingType?.value === 'Outsource') &&
                <div className="col-md-3">
                  <div className="Form_box">
                    {/* <label htmlFor={`Qty${index}`} for="Qty" className="form-label">
                      Qty
                    </label> */}
                    <input
                      type="number"
                      min="0"
                      step="any"
                      className="form-control"
                      onKeyDown={preventMinus}
                      id={`Qty}`}
                      onWheel={() => document.activeElement.blur()}
                      value={dishFiveSixMulti}
                      onChange={(e) => setDishFiveSixMulti(e.target.value)}
                    />
                  </div>
                </div>
                }
                <div className="Ingredients_title position-relative p-0" >
                  <h1>Ingredient&nbsp;({ingredientcount})</h1>
                  { catererdata != '1' &&
                  <button type="button" onClick={handleCopyDefaultIngredients}>Copay Default Ingredient</button>
                  }
                  <button type="button" onClick={handleAddSection}>Add Ingredient</button>
                </div>
  
                <div className="col-md-6">
                  <label htmlFor="Ingredients" className="form-label">
                    Ingredients
                  </label>
                </div>
                <div className="col-md-2">
                  <label htmlFor="Qty" for="Qty" className="form-label">
                    Qty
                  </label>
                </div>
                <div className="col-md-3">
                  <label htmlFor="Unit" for="Unit" className="form-label">
                    Unit
                  </label>
                </div>
                <div className="col-md-1">
                </div>
  
                {dishnum.length > 0 ? (
                  <>
                    {dishnum.map((item, index) => (
                      <div className="row" key={item.ingredient_name}>
                        <div className="col-md-6" >
                          <div className="Form_box">
                            <Select
                              onChange={(e) => handleIngredientUpdate(e, index)}
                              className="dropdown"
                              placeholder="Ingredients"
                              id={`Ingredients${index}`}
                              styles={colourStyles}
                              isClearable={false}
                              options={ingredientlist}
                              value={ingredientlist?.filter(function (option) {
                                return option?.value === ingredientlistdata[index];
                              })}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="Form_box">
                            <input
                              type="number"
                              placeholder="Qty"
                              className="form-control"
                              min="0"
                              step="any"
                              onKeyDown={preventMinus}
                              id={`Qty${index}`}
                              onWheel={() => document.activeElement.blur()}
                              onChange={(e) => {
                                const newQuality = [...quantityname];
                                newQuality[index] = e.target.value;
                                setquantityname(newQuality);
                              }}
                              value={ingredientlistdata[index] ? quantityname[index] : ""}
                              />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="Form_box">
                            <input
                            type="text"
                            placeholder="Unit"
                            className="form-control"
                            disabled
                            id="Qty"
                            value={ingredientlistdata[index] ? unitdatalist[index] : ""}
                          />
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="Form_box">
                            <button type="button" className="Remove_btn"onClick={() => handleRemoveSection(index)}>
                              <img src={remove} className="img-firud" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )
  
  
                  : (
                    // Render when Inventorydata is empty
                    <div className="No_Inventory">
                      <h1 >Add ingredient </h1>
                    </div>
                  )}
                <div className="Ingredients_title">
                 {/* <button onClick={() => handleSubmitCopy()}
                      type="button" id="modal_delete_btn2" data-bs-dismiss="offcanvas"
                      aria-label="Close" >Create Copy
                  </button> */}
                  {/* { niyaaz_type_view === 0 &&
                  <button onClick={() => handleCopyToMiqaat()}
                      type="button" id="modal_delete_btn2" data-bs-dismiss="offcanvas"
                      aria-label="Close" >Copy to Miqaat
                  </button>
                  } */}
                  <h1></h1>
                  <div className="Save_btn">
                    <button type="button" data-bs-dismiss="offcanvas"
                      aria-label="Close" id="modal_close_btn2">Cancel</button>
                    <button type="submit" onClick={handleSubmitUpdate} data-bs-dismiss="offcanvas"
                      aria-label="Close">Save Changes</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
    </div>
  )

        
}
